import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge4 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の預託金について' fontWeight={700} />
                <Heading3 title='ゴルフ会員権の預託金とは' />
                <p>
                    ゴルフ会員権の預託金制度とは、預託金制ゴルフ場において、そもそもゴルフ場を造る際、新規会員募集にてゴルフ場に一定の金額を預けて会員になり、所定の期間を経て所有者に返還されるものです。
                    <br />
                    預ける金額はゴルフ場ごとに異なり、預託金制のゴルフ会員権証券に記載されている金額です。また、預託金制ゴルフ会員権には譲渡性があり、株式のように市場で売買取引が可能です。
                    <br />
                    預託金制のゴルフ会員権の売買では、ゴルフ場を会員として利用できる優先利用権と預託金返還請求権のセットで譲渡人から譲受人に売買され、新しい会員に引き継がれていきます。
                    <br />
                    なお、ゴルフ場が会員権を発行する場合は、預託金には消費税はかかりませんが、会員権の譲渡は課税対象になります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='預託金と入会預託金の違いとは？' fontWeight={700} />

                <Heading3 title='入会預託金とは' />
                <p>
                    ゴルフ場へ入会する際に名義書換料の支払いがありますが、「一部のゴルフ場」にはそれとは別に入会預託金を支払わなくてはならない場合があります。
                    <br />
                    こちらは退会時にゴルフ場から返却される預託金のことです。ゴルフ場としては、コースメンテナンス費用、クラブハウスの再建や修理、ゴルフ場運営にかかる費用等を入会預託金からまかなっており、重要な資金源となっています。
                </p>

                <Heading3 title='預託金との違い' />
                <p>
                    この「一部のゴルフ場」に支払う入会預託金は、名義書換により入会した方は必ず新たにゴルフ場へ預けなければなりません。
                    <br />
                    預託金制ゴルフ場の会員権の売買においても、買い主は、売り主から「預託金制のゴルフ会員証券」を受け取りますが、ゴルフ場には別途入会預託金を預ける必要があります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の預託金は返ってくる？' fontWeight={700} />

                <Heading3 title='預託金は返還される' />
                <p>
                    入会金とは違い、預託金とはその名の通りゴルフ場に預けているのですから、ゴルフ場から返還されています。預託金制ゴルフ会員権の所有者は、契約時の据え置き期間が経過したら、ゴルフ場に預託金の返還を請求することができます。なお、返還を受けた預託金ですが、預けたお金を返してもらうだけですので確定申告の必要はありません。
                    <br />
                    <br />
                    <strong>
                        <u>（補足）法人のゴルフ会員権における預託金の取扱いついて</u>
                    </strong>
                    <br />
                    企業の財政状態を正しく財務諸表に反映させるため、ゴルフ会員権を含む金融商品を正しく仕訳し、時価評価を行う会計処理が求められています。企業が所有しているゴルフ会員権の時価が著しく下落したことによる減損処理をする場合には、帳簿価額のうち預託保証金（預託金）を上回る金額（通常は施設の優先的利用権にあたります）について、まずは直接評価損を計上し、さらに時価が預託金の額を下回る場合には、当該箇所を債権の勘定科目として貸倒引当金を設定します。預託金の回収が難しい場合には、貸倒引当金を設定しないで直接控除することが出来ます。（ただし、税務上はより厳密な条件を検討する必要があります）
                </p>

                <Heading3 title='預託金の返還に関するトラブル' />
                <p>
                    最近では落ち着きを見せてきているものの、かつてのバブル経済崩壊、そしてその後続く不況によりゴルフ会員権の市場価値はバブル期に比べて下がりました。そのため、ゴルフ会員権を所有している人は、市場で売却するよりも預託金の返還を求めるようになりました。ところが、一部のゴルフ場では預託金を日々の運営資金として使用しており、据え置き期間経過後であっても預託金の返還に応じることが難しく、過去には裁判になるケースもありました。相続に関しても、ゴルフ会員権を財産として所有しているものの相続人の中で誰もゴルフをする人がおらず、会員資格を返上して預託金返還を求めるため、弁護士に相談するケースもありました。
                    <br />
                    据え置き期間満了後も預託金が返還されない「預託金償還問題」の詳しい原因や対処法については
                    <a href='/knowledge/16'>預託金の償還</a>
                    で解説していますので、あわせてご参照ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='預託金会員権の現在' fontWeight={700} />
                <Heading3 title='預託金会員権は現在どうなっている？' />
                <p>
                    近年、預託金の株式化、預託金会員によるクラブの社団化、預託金なしでゴルフ場施設利用権のみのプレー会員権を発行する等の対策を講じるゴルフ場が増えてきています。
                    <br />
                    また、経営者が変わった場合の判例では、一定の要件を満たす場合に請求できる等、法的にも整備されつつあります。
                    <br />
                    ご入会検討のゴルフ場に関しても、情報量豊富な当社にご相談いただければ、このような事も含めてゴルフ会員権選びのアドバイスをさせていただきます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    預託金会員制度は日本特有の制度です。預託金はゴルフ場の重要な資金源となる一方で、この預託金の制度によって経営が困難になるゴルフ場も多く存在しました。しかし経営の透明性が求められている昨今においては、決算書等を定期的にそのゴルフ場会員に開示する優良ゴルフ場が増えてきています。また今後もゴルフ場はより一層の情報開示に取り組み、サービスの見直しを図り、会員に案内することが大切だと考えています。そうすることで現メンバーや多くのゴルファーから信頼を得て、また新たな会員が増えることにも繋がると考えます。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge4;
